import { render, staticRenderFns } from "./otpverify.vue?vue&type=template&id=a6a33cb6&scoped=true&"
import script from "./otpverify.vue?vue&type=script&lang=js&"
export * from "./otpverify.vue?vue&type=script&lang=js&"
import style0 from "./otpverify.vue?vue&type=style&index=0&id=a6a33cb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a33cb6",
  null
  
)

export default component.exports